import { Link } from 'react-router-dom';
import LevelAnimalIcon from '../../studentDashboard/components/LevelAnimalIcon';
import { getLevelForPoints } from '../../../config/levelsConfig';
import { useDailySpeaking } from '../hooks/useDailySpeaking';
import { QuizSkillPeek } from '../../dailyTest/components/QuizSkillPeek';
import '../../dailyTest/components/DailyTestCard.css';

/**
 * The dashboard's 每日口语 card, rendered beside the daily test's 听力/读写 cards
 * (DailyTestCard owns the deferral and passes `ready`).
 *
 * Nothing at all unless the server says this student is on the rollout and has
 * not finished today, so everyone else sees no change.
 *
 * @param {{ studentId: string, ready: boolean, isTeacherView?: boolean, points?: number }} props
 *   `ready` holds the fetch back until the dashboard is idle, like the quiz cards.
 */
export function DailySpeakingCard({ studentId, ready, isTeacherView = false, points = 0 }) {
  const { data } = useDailySpeaking(ready ? studentId : null);

  if (!data?.enabled || data.complete || !data.prompts?.length) return null;

  const level = getLevelForPoints(points);
  const body = (
    <>
      <span className="dt-card-icon" aria-hidden="true">
        <LevelAnimalIcon level={level.level} icon={level.icon} />
      </span>
      <span className="dt-card-info">
        <span className="dt-card-title">每日口语</span>
        <span className="dt-card-secondary">{data.prompts.length} 题 · 开口说英语</span>
      </span>
      <QuizSkillPeek skill="speaking" />
    </>
  );

  // A teacher previewing a student sees the card but cannot open it — answering
  // would record speech in the child's name.
  if (isTeacherView) return <div className="dt-card dt-card--speaking dt-card-readonly">{body}</div>;

  return (
    <Link
      to={`/daily-speaking/${studentId}`}
      // The finish screen shows the child's own level animal from these.
      state={{ points }}
      className="dt-card dt-card--speaking"
    >
      {body}
    </Link>
  );
}

export default DailySpeakingCard;
